@let activeThread = activeThread$ | async;
@let sideThread = sideThread$ | async;
@let activeThreadName = activeThreadName$ | async;
@let activeContextType = activeContextType$ | async;

<div class="size-full overflow-hidden">
    @if (activeContextType) {
        <section
            class="h-full rounded-r-2xl rounded-bl-2xl bg-surface-B px-16 py-20"
            [ngClass]="{
                'rounded-tl-2xl': activeContextType !== AIContextType.POST,
            }"
        >
            <div
                class="relative z-0 size-full"
                [ngClass]="{
                    'min-h-544 lg:min-h-fit':
                        activeContextType === AIContextType.POST,
                }"
            >
                <interacta-ai-panel-chat
                    class="absolute size-full bg-surface-B"
                    [aiPostAttachmentEnabled]="aiPostAttachmentEnabled"
                    [attr.aria-hidden]="activeThread !== MAIN_THREAD"
                    [attr.inert]="activeThread !== MAIN_THREAD ? '' : null"
                    [threadId]="MAIN_THREAD"
                />
                @if (sideThread) {
                    <interacta-ai-panel-chat
                        class="absolute z-10 size-full bg-surface-B transition-transform"
                        [attr.aria-hidden]="activeThread === MAIN_THREAD"
                        [attr.inert]="activeThread === MAIN_THREAD ? '' : null"
                        [ngClass]="{
                            'translate-x-0': activeThread !== MAIN_THREAD,
                            'translate-x-[110%]': activeThread === MAIN_THREAD,
                        }"
                        [style.transition-duration.ms]="ANIMATION_DURATION"
                        [threadId]="sideThread"
                        [threadName]="activeThreadName"
                    />
                }
            </div>
        </section>
    }
</div>
